<template>
  <div class="animated fadeIn rubros-trabajos">
    <b-row>
      <b-col xl="12">
        <b-card header="Información del Rubro">
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model"
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Descripción"
              label-for="descripcion"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="descripcion"
                v-model="$v.descripcion.$model" 
                rows="3"
                max-rows="6"
                :state="descripcionValida"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="descripcionFeedback">
                {{ descripcionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Plantilla"
              label-for="plantillaArticulos"
              :label-cols="labelCols"
              description="Plantilla para completar información de los artículos"
              horizontal>
              <b-form-textarea
                id="plantillaArticulos"
                v-model="$v.plantillaArticulos.$model" 
                rows="5"
                max-rows="5"
                :state="plantillaArticulosValida"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="plantillaArticulosFeedback">
                {{ plantillaArticulosInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Pje.Margen Mínimo"
              label-for="pjeMargenMinimo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="pjeMargenMinimo"
                v-model.trim="$v.pjeMargenMinimo.$model"
                :state="pjeMargenMinimoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="pjeMargenMinimoFeedback">
                {{ pjeMargenMinimoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label-for="premios"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="premios"
                  v-model="premios"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
                  Fee diferenciado (premios, reintegros y otros)
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              label-for="reembolsos"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="reembolsos"
                  v-model="reembolsos"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
                  Rubro de Reembolsos
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              v-if="accesoComisiones"
              label-for="excluidoComisiones"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="excluidoComisiones"
                  v-model="excluidoComisiones"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
                  Excluido del cálculo de Comisiones
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              label-for="requiereValidacionBrief"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="requiereValidacionBrief"
                  v-model="requiereValidacionBrief"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
                  Requiere Validación del Brief
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              label="Parámetros Globales"
              label-for="parametrosGlobales"
              :label-cols="labelCols"
              class="parametrosGlobales"
              horizontal>
              <b-form-checkbox 
                  id="parametrosGlobales"
                  v-model="parametrosGlobales"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
                  Parámetros para el cálculo del costo interno
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              label="Pje.Gastos Fijos"
              label-for="pjeGastosFijos"
              :label-cols="labelCols"
              v-if="!parametrosGlobales"
              horizontal>
              <b-form-input 
                id="pjeGastosFijos"
                v-model.trim="$v.pjeGastosFijos.$model"
                :state="pjeGastosFijosValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="pjeGastosFijosFeedback">
                {{ pjeGastosFijosInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Pje. Inversión Futura"
              label-for="pjeInversionFutura"
              :label-cols="labelCols"
              v-if="!parametrosGlobales"
              horizontal>
              <b-form-input 
                id="pjeInversionFutura"
                v-model.trim="$v.pjeInversionFutura.$model" 
                :state="pjeInversionFuturaValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="pjeInversionFuturaFeedback">
                {{ pjeInversionFuturaInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Pje. Impuestos Internos"
              label-for="pjeImpuestosInternos"
              :label-cols="labelCols"
              v-if="!parametrosGlobales"
              horizontal>
              <b-form-input 
                id="pjeImpuestosInternos"
                v-model.trim="$v.pjeImpuestosInternos.$model" 
                :state="pjeImpuestosInternosValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="pjeImpuestosInternosFeedback">
                {{ pjeImpuestosInternosInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              v-if="!parametrosGlobales"
              horizontal>
              <p class="description">En caso de querer modificar el % general de la fórmula base, indicar en cada casillero el % deseado.</p>
              <p class="description">La suma de los parámetros será lo que se aplique al costo estimado para llegar al costo interno</p>
            </b-form-group>

            <b-form-group
              label-for="inactivo"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
                Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { required, maxLength, decimal, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'rubrotrabajo/getField',
  mutationType: 'rubrotrabajo/updateField',
});

export default {
  name: 'RubrosTrabajosABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      pjeMargenMinimoValido: null,
      pjeMargenMinimoInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',
      plantillaArticulosValida: null,
      plantillaArticulosInvalidaMsj: '',
      pjeGastosFijosValido: null,
      pjeGastosFijosInvalidoMsj: '',
      pjeInversionFuturaValido: null,
      pjeInversionFuturaInvalidoMsj: '',
      pjeImpuestosInternosValido: null,
      pjeImpuestosInternosInvalidoMsj: '',

      labelCols: 2,
      accesoComisiones: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'pjeMargenMinimo',
      // 'pjeMargenMaximo',
      'premios',
      'reembolsos',
      'excluidoComisiones',
      'requiereValidacionBrief',
      'descripcion',
      'plantillaArticulos',
      'parametrosGlobales',
      'pjeGastosFijos',
      'pjeInversionFutura',
      'pjeImpuestosInternos',
      'inactivo',
    ])
  },
  created() {
    let rubroId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        rubroId = this.$route.params.id;
      }
    }

    let userRolId = parseInt(this.$store.getters['user/rolId']);
    switch (userRolId) {
      case 1:
      case 2: /* Direccion */
      case 8: /* Calidad */
      case 9: /* Director Ejecutivo */
      case 21: /* Responsable de Finanzas y Proveedores */
        this.accesoComisiones = true;
        break;
    }

    this.showSpinner();
    this.$store.dispatch('rubrotrabajo/inicializar', rubroId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "nombre" || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (this.$v.nombre.$error && !this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }      
          if (this.$v.nombre.$error && !this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del rubro';
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      if (campo == "pjeMargenMinimo" || validarTodos) {
        if (this.$v.pjeMargenMinimo.$error) {
          this.pjeMargenMinimoValido = false;

          if (!this.$v.pjeMargenMinimo.decimal) {
            this.pjeMargenMinimoInvalidoMsj = 'El margen mínimo debe ser un valor numérico positivo';
          } else if (!this.$v.pjeMargenMinimo.minValue) {
            this.pjeMargenMinimoInvalidoMsj = 'El margen mínimo debe ser un valor numérico positivo';
          } else if (!this.$v.pjeMargenMinimo.maxValue) {
            this.pjeMargenMinimoInvalidoMsj = 'El margen mínimo ingresado no es válido';
          }
        } else {
          this.pjeMargenMinimoValido = null;
          this.pjeMargenMinimoInvalidoMsj = '';
        }
      }

      // if (campo == "pjeMargenMaximo" || validarTodos) {
      //   if (this.$v.pjeMargenMaximo.$error) {
      //     this.pjeMargenMaximoValido = false;

      //     if (!this.$v.pjeMargenMaximo.decimal) {
      //       this.pjeMargenMaximoInvalidoMsj = 'El margen máximo debe ser un valor numérico positivo';
      //     } else if (!this.$v.pjeMargenMaximo.minValue) {
      //       this.pjeMargenMaximoInvalidoMsj = 'El margen máximo debe ser un valor numérico positivo';
      //     } else if (!this.$v.pjeMargenMaximo.maxValue) {
      //       this.pjeMargenMaximoInvalidoMsj = 'El margen máximo ingresado no es válido';
      //     }
      //   } else {
      //     this.pjeMargenMaximoValido = null;
      //     this.pjeMargenMaximoInvalidoMsj = '';
      //   }
      // }

      if (campo == "descripcion" || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (this.$v.descripcion.$error && !this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripción sólo puede contener hasta 500 caracteres';
          }      
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }

      if (campo == "plantillaArticulos" || validarTodos) {
        if (this.$v.plantillaArticulos.$error) {
          this.plantillaArticulosValida = false;
          if (this.$v.plantillaArticulos.$error && !this.$v.plantillaArticulos.maxLength) {
            this.plantillaArticulosInvalidaMsj = 'La plantilla para artículos sólo puede contener hasta 2500 caracteres';
          }      
        } else {
          this.plantillaArticulosValida = null;
          this.plantillaArticulosInvalidaMsj = '';
        }
      }

      if (campo == 'pjeGastosFijos' || validarTodos) {
        if (this.$v.pjeGastosFijos.$error) {
          this.pjeGastosFijosValido = false;
          if (!this.$v.pjeGastosFijos.decimal || !this.$v.pjeGastosFijos.minValue) {
            this.pjeGastosFijosInvalidoMsj = 'El porcentaje de gastos fijos ingresado no es válido';
          }     
        } else {
          this.pjeGastosFijosValido = null;
          this.pjeGastosFijosInvalidoMsj = '';
        }
      }

      if (campo == 'pjeInversionFutura' || validarTodos) {
        if (this.$v.pjeInversionFutura.$error) {
          this.pjeInversionFuturaValido = false;
          if (!this.$v.pjeInversionFutura.decimal || !this.$v.pjeInversionFutura.minValue) {
            this.pjeInversionFuturaInvalidoMsj = 'El porcentaje de inversión futura ingresado no es válido';
          }     
        } else {
          this.pjeInversionFuturaValido = null;
          this.pjeInversionFuturaInvalidoMsj = '';
        }
      }

      if (campo == 'pjeImpuestosInternos' || validarTodos) {
        if (this.$v.pjeImpuestosInternos.$error) {
          this.pjeImpuestosInternosValido = false;
          if (!this.$v.pjeImpuestosInternos.decimal || !this.$v.pjeImpuestosInternos.minValue) {
            this.pjeImpuestosInternosInvalidoMsj = 'El porcentaje de impuestos internos ingresado no es válido';
          }     
        } else {
          this.pjeImpuestosInternosValido = null;
          this.pjeImpuestosInternosInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('rubrotrabajo/save')
          .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    goList() {
      this.$router.push({ name: 'RubrosTrabajos' });
    },
  },
  watch: {
    'parametrosGlobales' : function(newVal, oldVal) {
      if ( newVal != oldVal) {
        if (newVal) {
          this.pjeGastosFijos = 0;
          this.pjeInversionFutura = 0;
          this.pjeImpuestosInternos = 0;
        }
      }
    },    
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
    pjeMargenMinimo: {
      decimal,
      minValue: minValue(0),
      maxValue: maxValue(999)
    },
    // pjeMargenMaximo: {
    //   decimal,
    //   minValue: minValue(0),
    //   maxValue: maxValue(999)
    // },
    pjeGastosFijos: {
      decimal,
      minValue: 0
    },
    pjeInversionFutura: {
      decimal,
      minValue: 0
    },
    pjeImpuestosInternos: {
      decimal,
      minValue: 0
    },
    descripcion: {
      maxLength: maxLength(500)
    },
    plantillaArticulos: {
      maxLength: maxLength(2500)
    },
  },  
}
</script>

<style>
  .custom-checkbox {
    top: 7px;
  }
  .rubros-trabajos .parametrosGlobales .custom-checkbox label {
    font-size: 80%;
    font-weight: 400;
    color: #73818f !important;
  }

  .rubros-trabajos p.description {
    font-size: 0.8em;
    font-style: italic;
    margin-bottom: 0;
  }

  .rubros-trabajos p.description:nth-child(2) {
    margin-bottom: 5px;
  }

  /* .custom-checkbox label {
    font-size: 80%;
    font-weight: 400;
    color: #73818f !important;
  } */
</style>
